import styled from 'styled-components';

export const StyledCarousel = styled.div`
  display: flex;
  height: 100%;
  position: relative;
  overflow: hidden;

  .carousel_mover {
    display: flex;
    position: absolute;
    top: 0;
    width: 100%;
    transition: 0.5s ease-in-out;
  }

  .carousel_navigation {
    display: flex;
    justify-content: center;
    position: absolute;
    bottom: 55px;
    width: 100%;
  }
`;

export const StyledCarouselItem = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  min-width: 100%;

  @media (max-width: 767px) {
    margin-top: 20px;
  }

  .more_link {
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.004em;
    padding: 7px 27px;
    color: #fff;
    text-decoration: unset;
    border-radius: 45px;
    background-color: #ef4923;
    cursor: pointer;
  }
`;

export const StyledNavigationButton = styled.button`
  background-color: unset;
  padding: unset;
  border: unset;
  cursor: pointer;

  span {
    display: flex;
    padding: 10px 3px;

    &:before {
      content: ' ';
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: #d9d9d9;
    }

    &.active {
      &:before {
        background-color: #ef4923;
      }
    }
  }
`;
